import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import * as QRCode from 'qrcode';
declare var $: any;

@Component({
  selector: 'app-setup-mfa',
  templateUrl: './setup-mfa.component.html',
  styleUrls: ['./setup-mfa.component.scss']
})
export class SetupMfaComponent implements OnInit {
  otpUri: string = '';
  qrCodeImage: string = '';
  verificationCode: string = '';
  message: string = '';
  errorEmptyCodeMessage: boolean = false;
  errorInvalidCodeMessage: boolean = false;
  user: any;

  mfaAlreadyConfigured: boolean = false;
  mfaVerified: boolean = false;
  loading: boolean = false;
  mfaModalDelete: boolean = false;

  constructor(private authService: AuthService) {}

  async ngOnInit() {
    this.user = await this.authService.currentAuthUser();
    const mfaType = this.user.preferredMFA;

    // console.log('MfaType: ', mfaType);

    if (mfaType === 'SOFTWARE_TOKEN_MFA' || mfaType === 'TOTP') {
      this.mfaAlreadyConfigured = true;
      return;
    }

    await this.generateQRCode();
  }

  private async generateQRCode() {
    this.otpUri = await this.authService.setupTotp(this.user);
    this.qrCodeImage = await QRCode.toDataURL(this.otpUri);
  }


  private resetMfaState() {
    this.mfaAlreadyConfigured = false;
    this.mfaVerified = false;
    this.verificationCode = '';
  }

  async verifyCode() {
    if (!this.verificationCode || this.verificationCode.trim() === '') {
      this.errorEmptyCodeMessage = true
      this.errorInvalidCodeMessage = false;
      return;
    }

    this.loading = true;
    this.message = '';

    try {
      await this.authService.verifyTotp(this.verificationCode);
      this.mfaVerified = true;
      $('#mfaConfiguredModal').modal('show');
      this.errorInvalidCodeMessage = false;
      this.errorEmptyCodeMessage = false;
      setTimeout(() => {
        $('#mfaConfiguredModal').modal('hide');
        this.mfaAlreadyConfigured = true;
      }, 3000);

    } catch (err) {
      this.errorEmptyCodeMessage = false;
      this.errorInvalidCodeMessage = true;
      console.error(err);
    } finally {
      this.loading = false;
    }
  }


  async disableMfaAndShowModal() {
     this.loading = true;
    try {
      await this.authService.disableTotp();
      $('#mfaDeletedModal').modal('show');
      this.resetMfaState();
      await this.generateQRCode();
    } catch (err) {
      this.resetMfaState();
      $('#mfaErrorDeletedModal').modal('show');
      console.error(err, 'Ocurrió un error al desactivar MFA.');
      this.loading = false;
    } finally {
       this.loading = false;
    }
  }

  async onDeleteConfirm(confirmed: boolean) {
    this.mfaModalDelete = false;
    if (confirmed) {
      await this.disableMfaAndShowModal();
    }
  }

  closeModal() {
    $('#mfaDeletedModal').modal('hide');
    $('#mfaErrorDeletedModal').modal('hide');
  }

}
